<style lang="scss">
@import '~scss/_variables';

.stat-fact {
    text-align: left;

    .described-icon {
        margin-top: 75px;
        text-align: left;
        color: $color-text-2;

        svg {
            margin-bottom: 5px;
            font-size: 72px;
        }
    }

    .value {
        margin-bottom: 0.29em;
        font-family: $font-family-2;
        font-size: 72px;
        font-weight: $font-weight-2-bold;
        line-height: 0.9;
        color: $color-white;

        small {
            font-size: 22px;
            font-weight: $font-weight-2-regular;
        }
    }

    .description {
        margin: 0 ($grid-size * 2);
        line-height: 1.44;
    }

    @include media-smaller('md') {
        .described-icon {
            margin: ($grid-size / 2) 0;

            svg {
                font-size: 48px;
            }
        }

        .value {
            margin-top: -12px;
            font-size: 48px;
        }

        .description {
            margin-left: $grid-size;
            margin-right: 0;
        }
    }
}
</style>

<template>
    <div class="stat-fact">
        <div class="described-icon">
            <fa :icon="icon"></fa>
            <p class="subtitle">{{ title }}</p>
        </div>

        <p class="value">
            <slot name="value"></slot>
        </p>

        <div class="description">
            <slot name="description"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ['icon', 'title']
};
</script>
